import React, { useState } from 'react';
import {
  Box,
  Button,
  VStack,
  Heading,
  Text,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Spinner,useDisclosure
} from '@chakra-ui/react';
import { useQuery } from 'react-query';
import PermissionForm from './PermissionForm';
import CustomSpinner from '../../EndedAuctions/CustomSpinner';

import { getPermissions } from '../../../services/permissionService';

const PermissionsList = () => {
  const toast = useToast();
  const { data: permissions, isLoading, isError, error } = useQuery('permissions', getPermissions, {
    onError: (err) => {
      toast({
        title: 'Error loading permissions',
        description: err.message,
        status: 'error',
        duration: 5000,
        isClosable: true
      });
    }
  });

  const [selectedPermissionId, setSelectedPermissionId] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleEdit = (id) => {
    setSelectedPermissionId(id);
    onOpen();
  };

  const handleAdd = () => {
    setSelectedPermissionId(null);
    onOpen();
  };

  if (isLoading) return <CustomSpinner />;
  if (isError) return <Text>Failed to load permissions: {error.message}</Text>;

  return (
    <Box>
      <Button onClick={handleAdd} colorScheme="blue" mb={4}>Add New Permission</Button>
      <VStack spacing={4} align="stretch">
        {permissions.map(permission => (
          <Box key={permission._id} p={5} shadow="md" borderWidth="1px">
            <Heading fontSize="xl">{permission.name}</Heading>
            <Text mt={4}>Method: {permission.method}</Text>
            <Text>Endpoint: {permission.endpoint}</Text>
            <Button colorScheme="green" onClick={() => handleEdit(permission._id)}>Edit</Button>
          </Box>
        ))}
      </VStack>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selectedPermissionId ? 'Edit Permission' : 'Create Permission'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <PermissionForm onClose={onClose} permissionId={selectedPermissionId} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default PermissionsList;
